/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Cloudflare_LabelInputs */

const tr_mesafeli_s11_cloudflare_label = /** @type {(inputs: Mesafeli_S11_Cloudflare_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Inc. (ABD/UE):`)
};

const en_mesafeli_s11_cloudflare_label = /** @type {(inputs: Mesafeli_S11_Cloudflare_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Inc. (USA/EU):`)
};

const de_mesafeli_s11_cloudflare_label = /** @type {(inputs: Mesafeli_S11_Cloudflare_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Inc. (USA/EU):`)
};

const ru_mesafeli_s11_cloudflare_label = /** @type {(inputs: Mesafeli_S11_Cloudflare_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Inc. (США/ЕС):`)
};

/**
* | output |
* | --- |
* | "Cloudflare Inc. (USA/EU):" |
*
* @param {Mesafeli_S11_Cloudflare_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_cloudflare_label = /** @type {((inputs?: Mesafeli_S11_Cloudflare_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Cloudflare_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_cloudflare_label(inputs)
	if (locale === "de") return de_mesafeli_s11_cloudflare_label(inputs)
	if (locale === "ru") return ru_mesafeli_s11_cloudflare_label(inputs)
	return tr_mesafeli_s11_cloudflare_label(inputs)
});